<div class="col-md-12 px-1">
  <div class="d-flex justify-content-center">
    <button
      class="btn btn-reset col text-center mt-4 mb-2"
      (click)="
        app.filterList.clear();
        app.filterList.open = true;
        app.filterFields.addQuickFilter('showAllCases')
      "
      [disabled]="
        app.filterList.fields.length <= 1 && app.state.filterByPage.length === 0
      "
      >
      <i class="fas fa-redo-alt"></i>
      {{ app.text.RM.resetFilter }}
    </button>
  </div>

  @for (box of boxes; track box) {
    <app-frame
      [title]="getHeaderText(box)"
      [changeHeader]="true"
      [filterBox]="true"
      >
      <ul class="list p-2">
        @for (field of app.filterList.getBoxFields(box); track field) {
          <li
            class="pb-2 d-flex"
            >
            @if (!isFilterSelected(field) && app.filterList.field != field) {
              <i
                class="fal fa-circle icon-size p-1 pointer"
                (click)="setField(field)"
              ></i>
            }
            @if (isFilterSelected(field) || app.filterList.field == field) {
              <i
                class="far fa-dot-circle icon-size selectedFilter p-1"
              ></i>
            }
            <a
              (click)="setField(field)"
              class="margin-top-3"
          [ngClass]="{
            selectedFilter: isFilterSelected(field),
            unSelected: !isFilterSelected(field)
          }"
              style="cursor: pointer"
              >
              {{ app.field.getLabel(field) }}
            </a>
          </li>
        }
      </ul>
    </app-frame>
  }
</div>
